/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import { Crate } from '@piwikpro/platform';
import AuthCrate from '@piwikpro/auth-crate';
import { RouterCrate } from '@piwikpro/router-crate/RouterCrate';
import { FeatureFlagsCrate } from '@piwikpro/feature-flags-crate/FeatureFlagsCrate';
import { TrafficMonitorCrate } from '@piwikpro/traffic-monitor-crate/TrafficMonitorCrate';
import ChangePlanOverlay from './components/ChangePlanOverlay';
import { MarketingService } from './MarketingService';
import { BillingService } from './BillingService';
import paymentsReducer from './redux';
import Billing from './components/Billing/Billing';
import ScheduledActionInformation from './components/ScheduledActionInformation';
import Checkout from './components/Checkout/Checkout';

@Crate({
  name: 'MarketingCrate',
  imports: [
    AuthCrate,
    RouterCrate,
    TrafficMonitorCrate,
    FeatureFlagsCrate
  ],
  services: [
    { name: 'marketingService', provide: MarketingService },
    { name: 'billingService', provide: BillingService },
  ],
  components: [
    { name: 'Checkout', provide: Checkout },
    { name: 'ChangePlanOverlay', provide: ChangePlanOverlay },
    { name: 'Billing', provide: Billing },
    { name: "ScheduledActionInformation", provide: ScheduledActionInformation }
  ],
  reducers: {
    payments: paymentsReducer,
  },
  bootstrap: ChangePlanOverlay,
})

export class MarketingCrate { }
